import { handleActions } from 'redux-actions'

import * as rawActions from '../../actions'

const defaultState = null

export default handleActions(
  {
    [rawActions.changeGalleryOpenedMenu](state, action) {
      return action.payload.menuAnchorEl
    },
    [rawActions.resetGalleryState](state, action) {
      return defaultState
    },
  },
  defaultState
)
